export default __webpack_public_path__ + "static/media/cLogo7.26fd788e.jpeg";